import React from 'react';
import { Card, CardContent } from './ui/card';
import { Zap, Shield, Heart } from 'lucide-react';

export const IntroductionSection = () => {
  return (
    <section id="introduccion" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Company Introduction */}
        <div className="text-center mb-16">
          <p className="text-xl text-slate-300 max-w-4xl mx-auto leading-relaxed">
            NOVOPAY nace con la visión de transformar la manera en que las personas y empresas gestionan su dinero. 
            Somos una solución integral que combina innovación tecnológica con un enfoque humano, ofreciendo operaciones rápidas, 
            seguras y sin límites de horario. Con nosotros, cada transferencia, pago o cobro se convierte en una experiencia 
            fluida y confiable.
          </p>
          
          <div className="mt-8 p-6 bg-yellow-500/10 rounded-xl border-l-4 border-yellow-500">
            <p className="text-lg text-yellow-100 font-semibold">
              📋 Cumplimos con todas las regulaciones financieras mexicanas y estamos autorizados por las autoridades competentes para operar servicios de pago y transferencia.
            </p>
          </div>
        </div>

        {/* Philosophy */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4">
              Nuestra Filosofía
            </h3>
            <p className="text-lg text-slate-300 max-w-3xl mx-auto">
              Creemos que la libertad financiera comienza con tres valores fundamentales: velocidad, seguridad y confianza.
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <Card className="text-center hover:shadow-xl transition-all duration-300 border border-slate-800 bg-slate-900">
              <CardContent className="p-8">
                <div className="w-16 h-16 bg-yellow-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Zap className="h-8 w-8 text-yellow-400" />
                </div>
                <h4 className="text-xl font-bold text-white mb-3">Velocidad</h4>
                <p className="text-slate-300">
                  Operaciones en tiempo real, sin esperas ni limitaciones de horario. 
                  Tu dinero cuando lo necesites.
                </p>
              </CardContent>
            </Card>
            
            <Card className="text-center hover:shadow-xl transition-all duration-300 border border-slate-800 bg-slate-900">
              <CardContent className="p-8">
                <div className="w-16 h-16 bg-yellow-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Shield className="h-8 w-8 text-yellow-400" />
                </div>
                <h4 className="text-xl font-bold text-white mb-3">Seguridad</h4>
                <p className="text-slate-300">
                  Protección de nivel bancario con tecnología de punta. 
                  Tus recursos siempre protegidos.
                </p>
              </CardContent>
            </Card>
            
            <Card className="text-center hover:shadow-xl transition-all duration-300 border border-slate-800 bg-slate-900">
              <CardContent className="p-8">
                <div className="w-16 h-16 bg-yellow-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Heart className="h-8 w-8 text-yellow-400" />
                </div>
                <h4 className="text-xl font-bold text-white mb-3">Confianza</h4>
                <p className="text-slate-300">
                  Transparencia total y control absoluto. 
                  Una relación basada en la confianza mutua.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* What We Do */}
        <div className="bg-slate-900 border border-slate-800 rounded-2xl p-8 md:p-12 text-white">
          <div className="text-center mb-8">
            <h3 className="text-2xl sm:text-3xl font-bold mb-4">
              Qué Hacemos
            </h3>
            <p className="text-xl text-slate-300 max-w-4xl mx-auto leading-relaxed">
              Ofrecemos soluciones completas de pago, cobro y transferencia para personas físicas, empresas y corporativos. 
              Nuestra infraestructura 100% digital permite realizar transacciones en tiempo real, los 365 días del año, 
              sin interrupciones.
            </p>
          </div>
          
          <div className="text-center">
            <div className="inline-block bg-yellow-500/20 rounded-lg px-6 py-3 mb-4">
              <p className="text-yellow-400 font-semibold text-lg">
                NOVOPAY es la herramienta ideal para quienes buscan optimizar su flujo financiero con tecnología de vanguardia.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
